import { z } from 'zod';

import { CourseWritableShape } from '../course-create/course-create';

/**
 * Editing a course (`courses.manage`).
 *
 * Partial, so the admin form can PATCH the publication switch without resending
 * both locales of the copy — and so a locale tab that was never opened cannot
 * blank the other language.
 */
export const CourseUpdateSchema = z.object(CourseWritableShape).partial().strict();

export type CourseUpdateRequest = z.infer<typeof CourseUpdateSchema>;
